import "@/App.css";
import "@/lib/session"; // initialize X-Session-Id axios default
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import AudioFlipPage from "@/pages/AudioFlipPage";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { AuthProvider } from "@/auth/AuthContext";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<AudioFlipPage />} />
            </Routes>
          </BrowserRouter>
          <Toaster
            position="top-center"
            richColors
            toastOptions={{
              className: "font-sans",
            }}
          />
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
